module.exports = __webpack_public_path__ + "static/media/menu-ua-1.acbc384b.svg";